import i18n from './i18n';

/* A label the DATABASE keeps in several languages, read in the reader's (2026-10-21). The server sends them side by
   side — `label` / `labelKo` / `labelVi` / `labelZh`, or `quoteEn` / `quoteKo` / … where the English one carries a
   suffix too — and a language with no word yet reads the English, so a row added tomorrow is still drawn.
   Only for what is SHOWN: the ticket mail keeps building its own English + Korean (TicketFormFields). */
const SUFFIX = { ko: 'Ko', vi: 'Vi', zh: 'Zh' };

export const langOf = (lang) => String(lang || i18n.language || 'en').slice(0, 2);

export const pickL10n = (obj, base, lang) => {
  if (!obj) return '';
  const english = obj[base] ?? obj[`${base}En`] ?? '';
  const suf = SUFFIX[langOf(lang)];
  return (suf && obj[`${base}${suf}`]) || english;
};

export default pickL10n;
